import { alpha, Box, CircularProgress, useTheme } from "@mui/material";
import React, { Suspense } from "react";
import Navbar, { NAVBAR_TOTAL_OFFSET } from "./Navbar";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../store/Slice/reducers";
import ScrollToTop from "../../Components/ScrollToTop";

const NewFooter = React.lazy(() => import("./NewFooter"));
const AuthModal = React.lazy(() => import("./AuthModal"));
const LoginModal = React.lazy(() => import("./LoginModal"));
const PWAPrompt = React.lazy(() => import("../../Components/PWAPrompt"));
import {
  useGetContactPageQuery,
  useGetFooterDataQuery,
} from "../../store/Slice/StaticsSlice/staticApi";

export default function MainLayout() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { pathname } = useLocation();
  const { register, login } = useSelector((state) => state.siteSlice);
  const hideNavbar =
    pathname.startsWith("/complete-") ||
    pathname.startsWith("/callback/payment/verify") ||
    pathname.startsWith("/profile");

  // Navbar/BottomNav only need to know auth status.
  // Adjust this selector path to wherever your auth state actually lives.
  const isAuthenticated = useSelector((state) =>
    Boolean(state.userSlice?.user),
  );
  const { data: footerData, isLoading: footerLoading } =
    useGetFooterDataQuery();
  const { data: contactData, isLoading: contactLoading } =
    useGetContactPageQuery();

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        "@supports (height: 100svh)": { minHeight: "100svh" },
        position: "relative",
        backgroundColor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        // BottomNav is fixed on mobile (bottom: 10, ~56px tall + safe area),
        // so reserve room for it under the page content.
        pb: { xs: "calc(78px + env(safe-area-inset-bottom))", sm: 0 },
      }}
    >
      <ScrollToTop />

      {/* Navbar is position: fixed (needed so it can hide/show on scroll
          without shoving layout around) and no longer takes up flow space.
          This spacer reserves its visual height so the Outlet always starts
          below it instead of underneath it. */}
      {/* {!hideNavbar && (
        <Box
          sx={{
            height: NAVBAR_TOTAL_OFFSET,
            // bgcolor: theme.palette.background.default,
            backgroundColor: theme.palette.background.paper,
          }}
        />
      )} */}

      <Box component="main" sx={{ flex: 1, background: "rgb(249,250,252)" }}>
        {!hideNavbar && <Navbar isAuthenticated={isAuthenticated} />}

        <Suspense
          fallback={
            <Box
              sx={{
                minHeight: "50vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                py: 6,
              }}
            >
              <CircularProgress size={32} sx={{ color: "primary.main" }} />
            </Box>
          }
        >
          <Outlet />
        </Suspense>
      </Box>

      <Suspense fallback={null}>
        <PWAPrompt />
        {Boolean(register) && (
          <AuthModal
            open={Boolean(register)}
            onClose={() => dispatch(closeModal())}
          />
        )}
        {Boolean(login) && (
          <LoginModal
            open={Boolean(login)}
            onClose={() => dispatch(closeModal())}
          />
        )}
      </Suspense>

      {!hideNavbar && (
        <Suspense fallback={<Box sx={{ minHeight: 400 }} />}>
          <NewFooter
            servicesLink={footerData?.data?.footerCategory}
            supportLinks={footerData?.data?.links}
            description={footerData?.data?.header?.description}
            ads={footerData?.data?.header?.ads || []}
            social={contactData?.data?.at(0)?.socialMedia || []}
            application={footerData?.data?.publishedApp}
          />
        </Suspense>
      )}
    </Box>
  );
}